import {httpReq} from "../../htttpReq";
import store from "../store";

export default {
  namespaced: true,

  state: {
    userData: [],
    id: ''
  },

  getters: {
    userData(state) {
      return state.userData;
    },

    id(state){
      return state.id
    }
  },

  mutations: {
    setData(state, data) {
      state.userData = data.data;
    },

    getId(state, payload){
      state.id = payload;
    }
  },

  actions: {
    getUserData({commit}) {
      store.commit('preloader/preloader', true);
      httpReq.get('user/application-review/' + this.getters['user/id'])
        .then(response => {
          commit('setData', response);
        })
        .catch((error) => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {
          store.commit('preloader/preloader', false);
        })
    },

  },
};
